import { LoansList } from './LoansList';

export default LoansList;
